var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 0.833496C4.93411 0.833496 0.832031 4.93558 0.832031 10.0002C0.832031 15.0647 4.93411 19.1668 9.9987 19.1668C15.0633 19.1668 19.1654 15.0647 19.1654 10.0002C19.1654 4.93558 15.0633 0.833496 9.9987 0.833496ZM9.9987 3.5835C11.5158 3.5835 12.7487 4.81641 12.7487 6.3335C12.7487 7.85516 11.5158 9.0835 9.9987 9.0835C8.48161 9.0835 7.2487 7.85516 7.2487 6.3335C7.2487 4.81641 8.48161 3.5835 9.9987 3.5835ZM9.9987 16.6002C7.70245 16.6002 5.68578 15.4268 4.4987 13.6485C4.52161 11.8289 8.16995 10.8252 9.9987 10.8252C11.8274 10.8252 15.4712 11.8289 15.4987 13.6485C14.3116 15.4268 12.2949 16.6002 9.9987 16.6002Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateUser);
export default __webpack_public_path__ + "static/media/UpdateUser.b5c770747be2545a98c61e4080c30d25.svg";
export { ForwardRef as ReactComponent };